import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import CurrentDateTime from "../components/CurrentDateTime";


function AppointmentScreen() {
  // const [bgImageLoaded, setBgImageLoaded] = useState(true);
  
  //     useEffect(() => {
  //     const img = new Image();
  //     img.src = "/assets/images/bookonline-bg1.jpg";
  //     img.onload = () => setBgImageLoaded(true);
  //     img.onerror = () => setBgImageLoaded(false);
  //   }, []);
  
  const location = useLocation();
  const { state } = location;
  const { encryptPayload } = require("../utils/custom-hash");


  const responseData = state && state.responseData;
 

  // Extract appointment details if responseData exists
  const appointmentDetails = responseData ? responseData : {};

  const navigate = useNavigate(); // Hook to navigate to the next component

  const [selectedDate, setSelectedDate] = useState(null);
  const [appointmentData, setAppointmentData] = useState({
    name: responseData ? responseData.name : "",
    contactNumber: responseData ? responseData.contactNumber : "",
    email: responseData ? responseData.email : "",
    branch: "",
    service: "",
    date: "",
    timeSlotId: "",
    branchName: "",
    serviceName: "",
    referenceCode: responseData ? responseData.referenceCode : "",
  });

  const [branches, setBranches] = useState([]); // State to store fetched branches
  const [services, setServices] = useState([]); // State to store fetched services
  const [timeslots, setTimeSlots] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(""); // State to store the selected time slot
  const [message, setMessage] = useState("");
  const [namemessage, setNameMessage] = useState("");
  const [phonemessage, setPhoneMessage] = useState("");
  const [emailmessage, setEmailMessage] = useState("");
  const [branchmessage, setBranchMessage] = useState("");
  const [servicemessage, setServiceMessage] = useState("");

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      // Only fetch the time slot if a valid date is selected
      setAppointmentData((prevData) => ({ ...prevData, date }));
      fetchTimeSlot(date, appointmentData.branch, appointmentData.service);
    } else {
      // Handle the case when the date is cleared (optional: reset or clear states)
      setAppointmentData((prevData) => ({ ...prevData, date: null }));
    }
  };


  // Function to handle the change in selected time slot
  const handleTimeSlotChange = (e) => {
    const selectedValue = e.target.value;
    

    setSelectedTimeSlot(selectedValue);

    const [timeSlotId] = selectedValue.split("|");
    setAppointmentData((prevData) => ({
      ...prevData,
      timeSlotId: Number(timeSlotId),
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_ASERVER}/api/appointment/branches`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setBranches(data.branches); // Assuming the API returns an array of branches in the "branches" field
       
      } catch (error) {
        alert("Error fetching branches: " + error.message);
      }
    };

    fetchData();
  }, []);

  const fetchService = async (branchId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/appointment/services/${branchId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (data.services && data.services.length > 0) {
        const activeServices = data.services;

        if (activeServices.length > 0) {
          setServices(activeServices);
        } else {
          setServices([]); // Set to an empty array if no active services
          alert("No active services available for this branch.");
        }
      } else {
        setServices([]); // Set to an empty array if no services at all
        alert("No services available for this branch.");
      }

    } catch (error) {
      alert("Error fetching services: " + error.message);
    }
  };

  const fetchTimeSlot = async (date, branchId, serviceId) => {
    if (!date || !branchId || !serviceId) return;

    setMessage("");
    const payload = { branchId, serviceId, date };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/appointment/timeSlots`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
     

      if (data.success) {
        const currentDate = new Date();

        // ✅ Ensure `date` is handled correctly
        const [year, month, day] = new Date(date)
          .toISOString()
          .split("T")[0]
          .split("-")
          .map(Number);
        const selectedDate = new Date(year, month - 1, day);
        selectedDate.setHours(0, 0, 0, 0); // Force local midnight

     

        const filteredTimeSlots = data.timeSlots.filter((slot) => {
          const [hours, minutes, seconds] = slot.startTime.split(":").map(Number);
          const slotTime = new Date(selectedDate);
          slotTime.setHours(hours, minutes, seconds, 0);

          return slotTime > currentDate || selectedDate > currentDate;
        });

        if (filteredTimeSlots.length === 0) {
          setMessage("Sorry, no available time slots for the selected date and time.");
        }

        setTimeSlots(filteredTimeSlots);
      } else {
        setMessage("Sorry, no available time slots for this day. Please choose another date.");
        setTimeSlots([]); // Clear timeSlots array
      }
    } catch (error) {
      alert("Error fetching timeslots: " + error.message);
    }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update appointmentData with the new value
    setAppointmentData((prevAppointmentData) => ({
      ...prevAppointmentData,
      [name]: value,
      branchName:
        name === "branch"
          ? e.target.options[e.target.selectedIndex].text
          : prevAppointmentData.branchName,
      serviceName:
        name === "service"
          ? e.target.options[e.target.selectedIndex].text
          : prevAppointmentData.serviceName,
    }));

    // Handle specific logic based on the field name
    if (name === "branch") {
      // Fetch related data (services) based on the selected branch
      fetchService(value);
    }

    if (name === "branch"  && value.trim() === "") {
      setBranchMessage("Please select a branch.");
      
    }else{
      setBranchMessage("");
    }

    if (name === "service") {
      setServiceMessage('');
      // Fetch related data (time slots) based on selectedDate, branch, and service
      fetchTimeSlot(selectedDate, appointmentData.branch, value);
    }

    // Real-time validation for name and phone
    if (name === "name" && value.trim() === "") {
      setNameMessage("Please enter a name.");
    } else {
      setNameMessage("");
    }

    // if (name === "email" && value.trim() === "") {
    //   setEmailMessage("Please enter a email address.");
    // }

    if (name === "email") {
      if (value.trim() === "") {
        setEmailMessage("Please enter an email address.");
      } else if (!/^\S+@\S+\.\S+$/.test(value)) {
        setEmailMessage("Please enter a valid email address.");
      } else {
        setEmailMessage(""); // Clear if valid
      }
    }
    

    if (name === "contactNumber") {
      if (!value) {
        setPhoneMessage("Please enter a phone number.");
      } else if (!/^\d+$/.test(value)) {
        setPhoneMessage("Enter a number.");
      } else if (value.startsWith("1")) {
        if (!/^\d{11}$/.test(value)) {
          setPhoneMessage("Enter a valid 11-digit phone number starting with 1.");
        } else {
          setPhoneMessage("");
        }
      } else {
        if (!/^\d{10}$/.test(value)) {
          setPhoneMessage("Enter a valid 10-digit phone number.");
        } else {
          setPhoneMessage("");
        }
      }
    }
    
    

    // if (name === "contactNumber" && value.trim() === "") {
    //   setPhoneMessage("Phone number is required");
    // } else {
    //   setPhoneMessage("");
    // }

  };

  const branchName = appointmentData.branchName;
  const serviceName = appointmentData.serviceName;


  const handleFormSubmit = async (event) => {
    event.preventDefault();
   
    let isError=0;
    if (!responseData && !appointmentData.name) {
      setNameMessage("Please enter a name.");
      isError=1;
     // return false;
    }

    // Validate contactNumber
    
    if (!appointmentData.contactNumber) {
      setPhoneMessage("Please enter a phone number.");
      isError = 1;
    } else {
      const phone = appointmentData.contactNumber;
    
      if (!/^\d+$/.test(phone)) {
        setPhoneMessage("Enter a number.");
        isError = 1;
      } else if (phone.startsWith("1")) {
        if (!/^\d{11}$/.test(phone)) {
          setPhoneMessage("Enter a valid 11-digit phone number starting with 1.");
          isError = 1;
        } else {
          setPhoneMessage("");
        }
      } else {
        if (!/^\d{10}$/.test(phone)) {
          setPhoneMessage("Enter a valid 10-digit phone number.");
          isError = 1;
        } else {
          setPhoneMessage("");
        }
      }
    }
     

    if (!responseData && !appointmentData.email) {
      setEmailMessage("Please enter an email address.");
      isError=1;
    } else if (
      appointmentData.email &&
      !/^\S+@\S+\.\S+$/.test(appointmentData.email)
    ) {
      setEmailMessage("Please enter a valid email address.");
      isError=1;
    } else {
      setEmailMessage(""); // Clear the message if valid
    }
    
    if (!responseData && !appointmentData.branch) {
      setBranchMessage("Please select a branch.");
      isError=1;
    }else{
      setBranchMessage("");
    }
    if (!appointmentData.service) {
      setServiceMessage("Please select a service.");
      isError=1;
    }else{
      setServiceMessage("");
    }

    if(isError === 1){
     return false;
    }

    if (!selectedTimeSlot) {
      console.error("No Date selected");
      setMessage("Please select a Date.");
      return;
    }

    const [timeSlotId, timeSlot] = selectedTimeSlot.split("|");
   

    if (!timeSlot) {
      console.error("Invalid time slot format");
      return;
    }

    const [timeStart, timeEnd] = timeSlot.split(" - ");
   
    if (!timeStart || !timeEnd) {
      console.error("Invalid time range format");
      
      return;
    }

    const scheduledOnDate = new Date(selectedDate)
      .toISOString()
      .split("T")[0];

    const requestData = {
      branchId: appointmentData.branch,
      serviceId: appointmentData.service,
      branchName: appointmentData.branchName,
      serviceName: appointmentData.serviceName,
      scheduledOn: scheduledOnDate,
      timeSlotId: Number(timeSlotId),
      timeStart,
      timeEnd,
    };

    // Always include email in the requestData
    if (appointmentData.email) {
      requestData.email = appointmentData.email;
    }

    if (appointmentData.name) {
      requestData.name = appointmentData.name;
    }

    if (appointmentData.contactNumber) {
      requestData.contactNumber = appointmentData.contactNumber;
    }


    // If rescheduling, add existing response data to requestData
    if (responseData && responseData.referenceCode) {
      requestData.referenceCode = responseData.referenceCode;
    }
   
    const encryptedPayload = await encryptPayload(requestData);
    const apiUrl = responseData
      ? `${process.env.REACT_APP_ASERVER}/api/appointment/re-schedule`
      : `${process.env.REACT_APP_ASERVER}/api/appointment/schedule`;

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encryptedPayload: encryptedPayload,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to save data");
        }
        return response.json();
      })
      .then((respData) => {
      
        navigate("/ticket-confirmation", {
          state: {
            responseData: respData,
            requestData: requestData,
          },
        });
      })
      .catch((error) => {
        console.error("Error saving data:", error);
      });
  };



  return (
    <section className="d-table w-100"
      id="home"
        style={{
       // backgroundImage: bgImageLoaded ? `url(/assets/images/bookonline-bg1.jpg)` : "none",
        backgroundColor:  "gray",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        backgroundAttachment: 'fixed',
        paddingTop: '80px',
      }}>
      <div className="container mt-25 mt-10">

        <div className="row justify-content-center">
          <CurrentDateTime />

          <div className="col-md-3">

          </div>

          <div className="col-md-9">

            <div className="card rounded p-4 ms-xl-3"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: '1px solid #424242',
                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px',
              }}>
              <h5 className="fw-bold text-black title-dark">Book Your Appointment Quickly and Easily</h5>
              <p style={{ fontSize: '12px', fontStyle: 'italic', color: '#396cf0' }}>
                {" "}
                Please provide manadatory (<span className="text-danger">*</span>)
                fields
              </p>
              <div className="custom-form">
                <div className="row">
                  <div className="col-lg-6 mb-2">
                    <label className="form-label" style={{ color: '#000' }}>
                      Name<span className="text-danger">*</span>
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="name"
                      className="form-control"
                      placeholder="Enter Your Name"
                      value={appointmentData.name}
                      onChange={handleInputChange}
                      required
                    />


                    {namemessage && (
                      <p style={{ color: "#f44336" }}>{namemessage}</p>
                    )}
                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="form-label" style={{ color:'#000' }}>
                      Phone Number<span className="text-danger">*</span>
                    </label>
                    <input
                      name="contactNumber"
                      id="contactNumber"
                      type="contactNumber"
                      className="form-control"
                      placeholder="Enter Your Phone"
                      value={appointmentData.contactNumber}
                      onChange={handleInputChange}
                      required
                    />


                    {phonemessage && (
                      <p style={{ color: "#f44336" }}>{phonemessage}</p>
                    )}
                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="form-label" style={{ color: '#000' }}>
                      Email Address<span className="text-danger">*</span>
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="email"
                      className="form-control"
                      placeholder="Enter Your Email"
                      value={appointmentData.email}
                      onChange={handleInputChange}
                     readOnly={!!responseData}
                      required
                    />
                   {!emailmessage && appointmentData.email && !/^\S+@\S+\.\S+$/.test(appointmentData.email) && (
                      <div className="text-danger">
                        Please enter a valid email address
                      </div>
                    )}

                    {emailmessage && (
                      <p style={{ color: "#f44336" }}>{emailmessage}</p>
                    )}

                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="form-label" style={{ color: '#000' }}>
                      Branch :<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control department-name select2input"
                      name="branch"
                      value={appointmentData.branch}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Branch</option>
                      {branches.map((branch) => (
                        <option key={branch.branchId} value={branch.branchId}>
                          {branch.branchName}
                        </option>
                      ))}
                    </select>
                    {branchmessage && (
                      <p style={{ color: "#f44336" }}>{branchmessage}</p>
                    )}
                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="form-label" style={{ color: '#000' }}>
                      Service :<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control department-name select2input"
                      name="service"
                      value={appointmentData.service}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Service</option>
                      {services.map((service) => (
                        <option
                          key={service.serviceId}
                          value={service.serviceId}
                        >
                          {service.serviceName}
                        </option>
                      ))}
                    </select>
                    {servicemessage && (
                      <p style={{ color: "#f44336" }}>{servicemessage}</p>
                    )}
                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="form-label" style={{ color: '#000' }}>
                      Select Date :<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      placeholder="dd/mm/yyyy"
                      value={
                        selectedDate ? selectedDate.toISOString().split("T")[0] : ""
                      }
                      min={new Date().toISOString().split("T")[0]} // Set today's date as the minimum
                      onChange={(e) =>
                        handleDateChange(e.target.value ? new Date(e.target.value) : null)
                      }
                      required
                    />
                    {message && <p style={{ color: "#f44336" }}>{message}</p>}
                  </div>


                  <div className="col-lg-6">
                    <div className="mb-2">
                      <label className="form-label" htmlFor="input-time" style={{ color: '#000' }}>
                        Time <span className="text-danger">*</span>
                      </label>

                      <select
                        name="timeSlot"
                        className="form-select"
                        id="input-time"
                        onChange={handleTimeSlotChange}
                      >
                        <option value="">Select Time Slot</option>
                        {timeslots.map((timeslot) => (
                          <option
                            key={timeslot.timeSlotId}
                            value={`${timeslot.timeSlotId}|${timeslot.startTime} - ${timeslot.endTime}`}
                          >
                            {timeslot.startTime} - {timeslot.endTime}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 mt-4">
                    <div className="d-grid">
                      <button
                        className="btn btn-primary"
                        onClick={handleFormSubmit}
                      >
                        {responseData
                          ? "Reschedule Appointment"
                          : "Book Appointment"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
  
}
export default AppointmentScreen;
